const updateCartCount = (count) => {
  const cartCountEl = document.querySelector('[data-cart-count]');
  if (!cartCountEl) return;
  cartCountEl.textContent = count;
  count > 0 ? cartCountEl.classList.remove('hidden') : cartCountEl.classList.add('hidden');
};

export default updateCartCount;
